import React from 'react'

// Дахин ашиглах loading болон empty-state бүрэлдэхүүн.
export function Loader({ className = '' }) {
  return (
    <div className={`w-full flex justify-center items-center py-16 ${className}`}>
      <div className='w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin' />
    </div>
  )
}

export function EmptyState({ message = 'Мэдээлэл олдсонгүй', className = '' }) {
  return (
    <div className={`w-full flex flex-col justify-center items-center py-16 text-slate-400 ${className}`}>
      <div className='text-4xl mb-2'><ion-icon name="file-tray-outline" /></div>
      <div className='text-sm'>{message}</div>
    </div>
  )
}

export default Loader
